function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "download-report-icon_svg__a",
  d: "M0 0h9.052v10.56H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "download-report-icon_svg__c",
  d: "M.047 0h3.395v3.772H.047z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#F2F3F6"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "download-report-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#download-report-icon_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#456673",
  d: "M.377 0A.378.378 0 000 .377v9.806c0 .208.17.377.377.377h8.297a.378.378 0 00.378-.377V3.384a.378.378 0 00-.755 0v6.422H.754V.754h5.252a.377.377 0 000-.754H.377z",
  mask: "url(#download-report-icon_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.61 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "download-report-icon_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#download-report-icon_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#456673",
  d: "M.801 1.381l1.432 1.637H.8V1.38zM.406.001a.379.379 0 00-.359.377v3.017c0 .208.169.377.377.377h2.64a.378.378 0 00.284-.627v.001L.709.13A.372.372 0 00.426 0l-.02.001h.001z",
  mask: "url(#download-report-icon_svg__d)"
})));

function SvgDownloadReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iY2poZmdwa3RuYSIgZD0iTTAgMEw5LjA1MiAwIDkuMDUyIDEwLjU2IDAgMTAuNTZ6Ii8+CiAgICAgICAgPHBhdGggaWQ9Iml1YjVoMWdpN2MiIGQ9Ik0wLjA0NyAwTDMuNDQyIDAgMy40NDIgMy43NzIgMC4wNDcgMy43NzJ6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8ZyBmaWxsPSIjRjJGM0Y2Ij4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDUpIj4KICAgICAgICAgICAgICAgICAgICA8bWFzayBpZD0iMWtzcGlkNW16YiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NqaGZncGt0bmEiLz4KICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzQ1NjY3MyIgZD0iTS4zNzcgMEMuMTcgMCAwIC4xNjkgMCAuMzc3djkuODA2YzAgLjIwOC4xNy4zNzcuMzc3LjM3N2g4LjI5N2MuMjA4IDAgLjM3OC0uMTY5LjM3OC0uMzc3VjMuMzg0YzAtLjIwOS0uMTctLjM3OC0uMzc4LS4zNzhzLS4zNzcuMTY5LS4zNzcuMzc4djYuNDIySC43NTRWLjc1NEg2LjAwNmMuMjA4IDAgLjM3Ny0uMTY5LjM3Ny0uMzc3UzYuMjE0IDAgNi4wMDYgMEguMzc3eiIgbWFzaz0idXJsKCMxa3NwaWQ1bXpiKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA1KSB0cmFuc2xhdGUoNS42MSkiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJmZ3VramZrNDNkIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjaXViNWgxZ2k3YyIvPgogICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjNDU2NjczIiBkPSJNLjgwMSAxLjM4MWwxLjQzMiAxLjYzN0guOFYxLjM4ek0uNDA2LjAwMWMtLjIuMDEtLjM1OC4xNzUtLjM1OS4zNzd2My4wMTdjMCAuMjA4LjE2OS4zNzcuMzc3LjM3N2gyLjY0Yy4yMDggMCAuMzc4LS4xNjkuMzc4LS4zNzcgMC0uMDk2LS4wMzYtLjE4Mi0uMDk0LS4yNXYuMDAxTC43MDkuMTNDLjY0LjA1LjUzOSAwIC40MjYgMEwuNDA2LjAwMWguMDAxeiIgbWFzaz0idXJsKCNmZ3VramZrNDNkKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgDownloadReportIcon as ReactComponent };